import React from 'react';
import _ from 'lodash';
import { Field, FieldRenderProps } from 'react-final-form';
import { Grid } from '@mui/material';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import { AcquisitionChannelItem } from './AcquisitionChannelItem';
import { AcquisitionChannelProps } from './types';
import { acquisitionChannelItems } from './constants';

export const AcquisitionChannel: React.FC<AcquisitionChannelProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const onSelectedStateChanged = (fieldValue: boolean, name: string) => {
    if (fieldValue && !value.includes(name)) {
      onChange(value.concat(name));
    }

    if (!fieldValue) {
      onChange(value.filter((item) => item !== name));
    }
  };

  return (
    <Grid container spacing={1.5}>
      {acquisitionChannelItems.map((item) => (
        <Grid key={item.value} item>
          <AcquisitionChannelItem
            icon={item.icon}
            label={item.label}
            value={value.includes(item.value)}
            onChange={onSelectedStateChanged}
            name={item.value}
            disabled={disabled}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export const AcquisitionChannelField: React.FC<{ name: string }> = ({ name }) => {
  const { isEditable } = useCanEditFormFieldsContext();
  const renderAcquisitionChannelField = (props: FieldRenderProps<string[]>) => {
    return (
      <AcquisitionChannel
        value={props.input.value || []}
        onChange={props.input.onChange}
        disabled={!isEditable}
      />
    );
  };

  return <Field<string[]> name={name} isEqual={_.isEqual} render={renderAcquisitionChannelField} />;
};
